<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-toolbar dark color="primary pl-2 pr-2" dense>
        <v-toolbar-title
          >Order History</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon dark @click="exist()">
          <v-icon>cancel</v-icon>
        </v-btn>
      </v-toolbar>
    </v-col>
    <v-col cols="12" md="12">
      <v-row no-gutters>
        <v-col
          v-for="(item, index) in historyList"
          :key="index"
          cols="6"
          md="3"
        >
          <v-card class="ma-1" outlined>
            <v-card-title class="primary white--text">
              <v-icon color="white" class="mr-2">event</v-icon>
              <h5>{{ item.date }}</h5>
            </v-card-title>
            <v-row no-gutters class="ml-2 mr-2" v-if="item.status=='first'">
              <v-col cols="12" md="12" class="red--text">
                <h4>{{item.title}}</h4>
              </v-col>
              <v-col cols="5" md="5">
                Id  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.historyId }} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                User  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.userName}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Status  
              </v-col>
              <v-col cols="7" md="7" class="blue--text">
                : {{item.saveOrupdate}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                From Branch  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.order.fromBranch}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                To Branch  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.order.toBranch}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                To Branch  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.order.orderDate}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                To Branch  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.order.orderDate}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Code
              </v-col>
              <v-col cols="7" md="7" class="blue--text">
                : {{item.order.code}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" md="12" class="red--text">
                Restaurant
              </v-col>
              <v-col>
                <v-row no-gutters
                v-for="(rest, index) in item.order.restList"
          :key="index">
          <v-col cols="5" md="5">
                Name
              </v-col>
              <v-col cols="7" md="7">
                : {{rest.restName}} 
              </v-col>
<v-col cols="5" md="5">
                Phone
              </v-col>
              <v-col cols="7" md="7">
                : {{rest.restPhone}} 
              </v-col>
              <v-col cols="5" md="5">
                Address
              </v-col>
              <v-col cols="7" md="7">
                : {{rest.restAddress}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
                  </v-row>
              </v-col>
              </v-row>
              <v-row no-gutters class="ml-2 mr-2" v-if="item.status=='third'">
              <v-col cols="12" md="12" class="red--text">
                <h4>{{item.title}}</h4>
              </v-col>
              <v-col cols="5" md="5">
                Id  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.historyId }} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                User  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.userName}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Status  
              </v-col>
              <v-col cols="7" md="7" class="blue--text">
                : {{item.saveOrupdate}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" md="12" class="red--text">
                Customer
              </v-col>
              <v-col cols="5" md="5">
                Name  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.collect.custName}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Phone  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.collect.custPhone}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Address  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.collect.custAddress}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Collect Date  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.collect.collectDate}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Cash
              </v-col>
              <v-col cols="7" md="7">
                : {{item.collect.customerPaid}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Kpay 
              </v-col>
              <v-col cols="7" md="7">
                : {{item.collect.kpay}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                WavePay 
              </v-col>
              <v-col cols="7" md="7">
                : {{item.collect.waypay}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                OtherPay
              </v-col>
              <v-col cols="7" md="7">
                : {{item.collect.otherPay}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" md="12" class="red--text">
                Restaurant
              </v-col>
              <v-col>
              <v-row no-gutters
                v-for="(rest, index) in item.collect.restList"
          :key="index">
              <v-col cols="12" md="12">
               {{rest.restName}} 
              </v-col>
              <v-col cols="12" md="12" class="ml-4">
                {{rest.itemName}} 
              </v-col>
               <v-col cols="5" md="5">
                Rest Amount
              </v-col>
              <v-col cols="7" md="7">
                : {{rest.restAmount}} 
              </v-col>
              <v-col cols="5" md="5">
                Rest Discount
              </v-col>
              <v-col cols="7" md="7">
                : {{rest.restDiscount}} 
              </v-col>
              <v-col cols="5" md="5">
                Rest DisAmount
              </v-col>
              <v-col cols="7" md="7">
                : {{rest.restDisAmount}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              </v-row>
              </v-col>
              </v-row>
              <v-row no-gutters class="ml-2 mr-2" v-if="item.status=='four'">
              <v-col cols="12" md="12" class="red--text">
                <h4>{{item.title}}</h4>
              </v-col>
              <v-col cols="5" md="5">
                Id  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.historyId }} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                User  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.userName}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Status  
              </v-col>
              <v-col cols="7" md="7" class="blue--text">
                : {{item.saveOrupdate}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" md="12" class="red--text">
                {{item.collect.custName}} 
              </v-col>
              <v-col cols="5" md="5">
                Remark
              </v-col>
              <v-col cols="7" md="7">
                : {{item.collect.remark}} 
              </v-col>
              </v-row>
              <v-row no-gutters class="ml-2 mr-2" v-if="item.status=='five'">
              <v-col cols="12" md="12" class="red--text">
                <h4>{{item.title}}</h4>
              </v-col>
              <v-col cols="5" md="5">
                Id  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.historyId }} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                User  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.userName}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Status  
              </v-col>
              <v-col cols="7" md="7" class="blue--text">
                : {{item.saveOrupdate}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" md="12" class="red--text">
                {{item.collect.custAddress}} 
              </v-col>
              <v-col cols="5" md="5">
                Date  
              </v-col>
              <v-col cols="7" md="7" >
                : {{item.collect.collectDate}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Payment  
              </v-col>
              <v-col cols="7" md="7" >
                : {{item.collect.amount}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Remark  
              </v-col>
              <v-col cols="7" md="7" >
                : {{item.collect.remark}} 
              </v-col>
              </v-row>
              <v-row no-gutters class="ml-2 mr-2" v-if="item.status=='delistatus'">
              <v-col cols="12" md="12" class="red--text">
                <h4>{{item.title}}</h4>
              </v-col>
              <v-col cols="5" md="5">
                Id  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.historyId }} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                User  
              </v-col>
              <v-col cols="7" md="7">
                : {{item.userName}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="5">
                Status  
              </v-col>
              <v-col cols="7" md="7" class="blue--text">
                : {{item.saveOrupdate}} 
              </v-col>
               <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
               <v-col cols="12" md="12" class="red--text">
                {{item.collect.custAddress}} 
              </v-col>
              </v-row>
              </v-card>
              </v-col>
              </v-row>
    </v-col>
  </v-row>
  
</template>
<script>
import historyService from "../service/HistoryService";
export default {
  data: () => ({
    historyList:[]
  }),
  props: {orderId:Number,refreshId:Number},
  mounted: function () {
     this.getHistory();
  },
  methods: {
    getHistory:function(){
      historyService
          .getHistoryByItemId(this.orderId)
          .then((response) => {
            this.historyList.splice(0);
            this.historyList.push(...response);
          })
          .catch(err => {
              this.$swal("Failed", err.response.data.message, "error");
          });
    },
    exist: function () {
      this.$emit("closeDialog");
    },
  },
  watch: {
    refreshId:function(){
      this.getHistory();
    }
  },
  components: {},
};
</script>
<style scoped>
</style>